// AdminDashboard.js
import React from 'react';
import Layout from './Layout';

const Plans = () => (
  <Layout>
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Plans</h2>
      <div className="bg-white p-4 rounded shadow">
        <p>Plans .</p>
      </div>
    </div>
  </Layout>
);

export default Plans;
